import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ModelHelpers } from '../../../models/ModelHelpers';
import { PSDatosGeneralesModel, ValoresEstadoPS } from '../../../models/ps-datos-generales-model';
import { AuthService } from '../../../services/auth.service';
import { ClientesService } from '../../../services/clientes.service';
import { LocalizationService } from '../../../services/localization.service';
import { PsDatosGeneralesService } from '../../../services/ps-datos-generales.service';
import { TasacionesService } from '../../../services/tasaciones.service';
import { ValidadorServiceService } from '../../../services/validador-service.service';
import { ClientesComponent } from '../../clientes/clientes.component';
import { ControlLookupComponent } from '../../control-lookup/control-lookup.component';
import { PsAcuerdoPosteriorEditComponent } from '../ps-acuerdo-posterior-edit/ps-acuerdo-posterior-edit.component';
import { PsAcuerdosBasicosEditComponent } from '../ps-acuerdos-basicos-edit/ps-acuerdos-basicos-edit.component';
import { PsAcuerdosListComponent } from '../ps-acuerdos-list/ps-acuerdos-list.component';
import { PsRevisionComponent } from '../ps-revision/ps-revision.component';
import { DialogHelperService } from '../../../services/dialog-helper.service';
import { PsRevisionFinComponent } from '../ps-revision-fin/ps-revision-fin.component';
import { ToastrService } from 'ngx-toastr';
import { GlobalUIUtilsService } from '../../../services/global-ui-utils.service';

@Component({
  selector: 'app-ps-datos-generales-edit',
  templateUrl: './ps-datos-generales-edit.component.html',
  styleUrls: ['./ps-datos-generales-edit.component.scss']
})
export class PsDatosGeneralesEditComponent implements OnInit {

  @ViewChild('lookupCliente', { static: true }) lookupCliente: ControlLookupComponent;
  @ViewChild('acuerdos', { static: false }) acuerdosComponent: PsAcuerdosListComponent;
  @ViewChild('psRevision', { static: false }) psRevisionComponent: PsRevisionComponent;
  @ViewChild('psAcuerdoBasico', { static: false }) psAcuerdoBasico: PsAcuerdosBasicosEditComponent;

  formGroup: FormGroup;
  id: number;
  model: PSDatosGeneralesModel;
  title: string = "Crear proyecto significativo";
  errorMessage: string;
  isEdit: boolean = false;
  finalidadList: any;
  validadoresList: any;
  sectoresList: any;
  normativasList: any;
  estados: any;
  isLookup: boolean = false;
  isEnCurso: boolean = false;
  disableClosePs: boolean = true;

  customFieldNamesError = {
    clienteId: 'cliente',
    finalidadId: 'finalidad de la tasación',
    sectorId: 'industria / sector',
    normativaId: 'normativa',
    responsableClienteId: 'responsable cliente',
    importePresupuesto: 'importe'
  };

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, private _clientesService: ClientesService,
    private _PsDatosGeneralesService: PsDatosGeneralesService, public _authService: AuthService, private _tasacionesService: TasacionesService,
    private _router: Router, public localization: LocalizationService, private _validadorService: ValidadorServiceService,
    private _dialog: MatDialog, @Optional() public dialogRef: MatDialogRef<PsDatosGeneralesEditComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private _dialogHelper: DialogHelperService, private _globalUIUtilsService: GlobalUIUtilsService,
    private _toastr: ToastrService) {

    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    }

    if (this.id != null) {
      this.isEdit = true;
      this.title = 'Editar Proyecto significativo';
    }

    if (data != undefined) {
      this.isLookup = data.isLookup;
    }

    this.formGroup = this._fb.group({
      // ID: [''],
      refPS: [{ value: '', disabled: true }],
      clienteId: ['', Validators.required],
      finalidadId: ['', Validators.required],
      normativaId: ['', Validators.required],
      importePresupuesto: [null, Validators.required],
      responsableClienteId: ['', Validators.required],
      sectorId: ['', Validators.required],
      te_PPA: [''],
      te_Val_Maquinaria: [''],
      te_Val_Inmobiliaria: [''],
      te_Val_Intangibles: [''],
      te_Val_Empresa: [''],
      te_Val_Otros: [''],
      te_Val_Consultoria: [''],
      deadline: [null],
      fechaFin: [{ value: '', disabled: true }],
      estadoPS: [{ value: '', disabled: true }],
      estadoNombre: [{ value: '', disabled: true }],
    });
  }

  ngOnInit() {
    this._authService.authIsLoaded.then(() => {
      this.loadData();
      this.formInit();
    });

  }

  formInit() {
    this.lookupCliente.serviceSource = (query: string) => {
      return this._clientesService.getClientesLookup(query);
    };
    this.lookupCliente.serviceSourceById = (id: number) => {
      if (id != null) {
        return this._clientesService.getClientesLookupId(id);
      }
    };

    this.lookupCliente.advancedLookupComponent = ClientesComponent;
    this._globalUIUtilsService.hide();
  }

  bindFromModel() {
    this.formGroup.patchValue(this.model);
  }

  async loadData() {
    this._globalUIUtilsService.show();

    if (this.isEdit) {
      await this.onRefresh();
      this.displayButtons();
    } else {
      this.model = new PSDatosGeneralesModel();
    }

    this.loadCombos();
  }

  loadCombos() {
    this._tasacionesService.getFinalidad().subscribe(data => this.finalidadList = data);
    this._validadorService.getValidadores().subscribe(data => this.validadoresList = data);
    this._PsDatosGeneralesService.getTipoNormativaList().subscribe(data => this.normativasList = data);
    this._PsDatosGeneralesService.getSectorList().subscribe(data => this.sectoresList = data);
    this._PsDatosGeneralesService.getPsEstados().subscribe(data => this.estados = data);
  }

  async onRefresh(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._PsDatosGeneralesService.getById(this.id).subscribe({
        next: (resp: PSDatosGeneralesModel) => {
          this.model = resp;
          this.formGroup.patchValue(this.model);
          resolve();
        },
        error: (err) => {
          this.errorMessage = err;
          reject(err);
        }
      });
    });
  }

  displayButtons() {
    if (this.model.estadoPS === ValoresEstadoPS.EnCurso) {
      this.disableClosePs = false;
      this.isEnCurso = true;
    } else {
      this.isEnCurso = false;
      this.disableClosePs = true;
    }
  }

  async save() {
    this.errorMessage = null;
    ModelHelpers.copyFromForm(this.formGroup.value, this.model);

    if (!this.formGroup.valid) {
      console.log(this.formGroup.errors);
      this.errorMessage = ModelHelpers.getFormValidationErrors(this.formGroup, this.customFieldNamesError);
      // this.errorMessage = 'Error de validación';
      return;
    }

    if (!this.isEdit) {
      try {
        const data: any = await this._PsDatosGeneralesService.post(this.model).toPromise();

        if (data.correct === false) {
          this.errorMessage = data.mensaje;
          return;
        }

        this.id = data.mensaje;
        await this.psAcuerdoBasico.save(this.id);

        if (!this.isLookup) {
          await this._router.navigate([`/proyecto-significativo/edit/${this.id}`]);
          await this.psRevisionComponent.reLoadData();
          await this.acuerdosComponent.reLoadAcuerdoBasicoPromise();
        } else {
          this.dialogRef.close(true);
        }
      } catch (err) {
        this.errorMessage = err;
      }

    } else {

      console.log('save')
      this.psRevisionComponent.save();
      this.psRevisionComponent.saveRICS();

      this._PsDatosGeneralesService.put(this.id, this.model)
        .subscribe((data) => {
          if (data.correct === false) {
            this.errorMessage = data.mensaje;
            return;
          }
          this._toastr.success("Guardado");
          // else {
          //   this._router.navigate(['/administracion']);
          // }
        }, err => { this.errorMessage = err; }
        );
    }
  }

  createAcuerdoBasico() {
    var dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.minWidth = '95vw'
    dialogConfig.data = {
      idPs: this.id
    }

    const ref = this._dialog.open(PsAcuerdosBasicosEditComponent, dialogConfig);
    ref.afterClosed().subscribe(result => {
      // this.getData();
    });
  }

  createAcuerdoPosterior() {
    var dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '60vw'
    dialogConfig.data = {
      idPs: this.id
    }

    const ref = this._dialog.open(PsAcuerdoPosteriorEditComponent, dialogConfig);
    ref.afterClosed().subscribe(result => {
      if (result) {
        this.psRevisionComponent.reLoadData();
        this.acuerdosComponent.loadData();
      }
    });
  }

  cancel(): void {
    if (!this.isLookup) {
      this._router.navigate(['/proyecto-significativo-list']);
    } else {
      this.dialogRef.close();
    }
  }

  closePs() {
    // Concluir revisión y cerrar proyecto significativo
    var dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '40vw'
    dialogConfig.data = {
      idps: this.id
    }

    const ref = this._dialog.open(PsRevisionFinComponent, dialogConfig);
    ref.afterClosed().subscribe(result => {
      if (result && result.completed) {
        this.model.fechaFin = result.date;
        this.model.estadoPS = ValoresEstadoPS.Finalizado;

        this.psRevisionComponent.save();
        this.psRevisionComponent.saveRICS();

        this._PsDatosGeneralesService.put(this.id, this.model)
          .subscribe({
            next: async (data) => {
              if (data.correct === false) {
                this.errorMessage = data.mensaje;
                return;
              }
              await this.onRefresh();
              this.displayButtons();
            },
            error: (err) => {
              this.errorMessage = err;
            }
          });
      }
    });
  }

  cancelPs() {
    var dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.closeOnNavigation = true;

    this._dialogHelper.defaultDialog('Anular proyecto', 'Confirmar', '¿Está seguro de querer anular el proyecto?',
      async () => {
        this.model.estadoPS = ValoresEstadoPS.Anulado;
        this._PsDatosGeneralesService.put(this.id, this.model)
          .subscribe(async (data) => {
            if (data.correct === false) {
              this.errorMessage = data.mensaje;
              return;
            }
            await this.onRefresh();
            this.displayButtons();
          }, err => { this.errorMessage = err; }
          );
      })
  }

  get form() {
    return this.formGroup.controls;
  }

}
